"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = __importDefault(require("./Button"));
var LoadingIcon_1 = __importDefault(require("./LoadingIcon"));
var StyledButton = styled_components_1["default"](Button_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var isLoading = _a.isLoading, theme = _a.theme;
    return isLoading &&
        "\n    position: relative;\n    color: " + theme.colors.transparent + ";\n\n    & > svg {\n      position: absolute;\n      left: calc(50% - 0.75em);\n    }\n  ";
});
var LoadingButton = function (_a) {
    var isLoading = _a.isLoading, children = _a.children, rest = __rest(_a, ["isLoading", "children"]);
    return (react_1["default"].createElement(StyledButton, __assign({ isLoading: isLoading }, rest),
        isLoading ? (react_1["default"].createElement(LoadingIcon_1["default"], { width: "1.5em", height: "1.5em", color: "primaryText", backgroundColor: "primary" })) : null,
        children));
};
LoadingButton.displayName = 'LoadingButton';
LoadingButton.defaultProps = {
    isLoading: false
};
exports["default"] = LoadingButton;
var templateObject_1;
//# sourceMappingURL=LoadingButton.js.map